import React from 'react';
import { CONTACTS } from '../../../utils/imports';
import { OMB_RES_BURDEN } from './OmbInfo';

const ProcessTimeline = () => (
  <>
    <h2>What to know before you fill out this form</h2>

    <va-process-list>
      <va-process-list-item header="Check your eligibility">
        <p className="vads-u-margin-top--2">
          Check the eligibility requirements before you apply.
        </p>
        <p>
          <va-link
            text="Find out if you’re eligible for VA healthcare"
            href="/health-care/eligibility/"
          />
        </p>
        <p>
          <strong>Note:</strong> We can help connect you with mental
          healthcare&mdash;no matter your discharge status, service history, or
          eligibility for VA healthcare.
        </p>
        <p>
          <va-link
            text="Find out how to get mental healthcare"
            href="/health-care/health-needs-conditions/mental-health/"
          />
        </p>
      </va-process-list-item>

      <va-process-list-item header="Gather your information">
        <p className="vads-u-margin-top--2">
          <strong>You’ll need to provide this information:</strong>
        </p>
        <ul>
          <li>
            <strong>Social Security numbers</strong> for you and any spouse or
            dependents you may have.
          </li>
          <li>
            <strong>Insurance card information</strong> for all health insurance
            companies that cover you. This includes coverage that you get
            through a spouse or significant other. This also includes Medicare,
            private insurance, or insurance from your employer.
          </li>
        </ul>

        <p>You can also provide this information:</p>
        <ul>
          <li>
            <strong>Your military service history information</strong>. This
            includes details about exposure to toxins or hazards.
          </li>
          <li>
            <strong>Your DD214 or other discharge papers</strong>. If you sign
            in, we may be able to prefill your military service history
            information. If you don’t sign in, you can upload a copy of your
            DD214 or other discharge or separation documents.
          </li>
          <li>
            <strong>Income information</strong> for you and any spouse or
            dependents you may have. This includes income from a job and any
            other sources.
          </li>
          <li>
            <strong>Deductible expenses</strong> (expenses that you can subtract
            from your income) for you and your spouse. These expenses will lower
            the amount of money we count as income.
          </li>
        </ul>
      </va-process-list-item>

      <va-process-list-item header="Start your application">
        <p className="vads-u-margin-top--2">
          We’ll take you through each step of the process. It should take about{' '}
          {OMB_RES_BURDEN} minutes.
        </p>
        <va-additional-info trigger="What happens after you apply">
          <div>
            <p className="vads-u-margin-top--0">
              We typically process healthcare applications within a week. We’ll
              send you a letter in the mail with our decision.
            </p>
            <p className="vads-u-margin-bottom--0">
              If you don’t receive your decision letter within a week after you
              apply, don’t apply again. Call us at{' '}
              <va-telephone contact={CONTACTS['222_VETS']} /> (
              <va-telephone contact={CONTACTS['711']} tty />
              ). We’re here Monday through Friday, 8:00 a.m. to 8:00 p.m.{' '}
              <dfn>
                <abbr title="Eastern Time">ET</abbr>
              </dfn>
              .
            </p>
            <p>
              <va-link
                text="Learn more about what happens after you apply"
                href="/health-care/after-you-apply/"
              />
            </p>
          </div>
        </va-additional-info>
      </va-process-list-item>
    </va-process-list>
  </>
);

export default ProcessTimeline;
